<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import { ref } from '@vue/composition-api'
import { mapActions } from 'vuex'
import { getAppConfig } from '@/utils/config.js'

	export default {
	name: 'App',
	setup() {
		const globalData = ref({
			token: '',
			isLogin: false,
			// 统一配置管理 - 从config.js获取
			config: getAppConfig()
		})

		return {
			globalData
		}
	},
	
	methods: {
		...mapActions('user', ['initAuth'])
	},
	
	onLaunch: async function() {
		try {
			// 初始化用户认证状态
			const isLoggedIn = await this.initAuth()
		} catch (error) {
			// 初始化用户认证状态失败
		}
	},
	
	onShow: function() {
		// App Show
	},
	
	onHide: function() {
		// App Hide
	}
}
</script>

<style lang="scss">
/* 引入TuniaoUI主题变量 */
@import './tuniao-ui/theme.scss';

/* 引入TuniaoUI全局样式 */
@import './tuniao-ui/index.scss';

/* 引入TuniaoUI图标库 */
@import './tuniao-ui/iconfont.css';

/* 其他全局样式 */
page {
	background-color: #f8f8f8;
}

/* 底部导航栏悬浮效果和圆角样式 */
/* #ifdef H5 */
uni-tabbar {
	background: linear-gradient(160deg, 
		rgba(208, 230, 255, 0.45) 20%, 
		rgba(255, 255, 255, 0.5) 50%, 
		rgba(255, 237, 224, 0.45) 80%
	) !important;
	backdrop-filter: blur(20px) saturate(150%) !important;
	-webkit-backdrop-filter: blur(20px) saturate(150%) !important;
	border-radius: 20px !important;
	box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.05) !important;
	margin: 0 12px 12px 12px !important;
	position: fixed !important;
	bottom: 0 !important;
	left: 0 !important;
	right: 0 !important;
	z-index: 999 !important;
	width: auto !important;
}

/* 中间图标3D效果 */
.uni-tabbar-item:nth-child(3) .uni-tabbar__icon {
	transform: translateY(-2px) scale(1.2) !important;
	transition: all 0.3s ease !important;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
	border-radius: 12px !important;
	padding: 6px !important;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.4)) !important;
	backdrop-filter: blur(5px) !important;
	-webkit-backdrop-filter: blur(5px) !important;
}

/* 中间图标激活状态 */
.uni-tabbar-item:nth-child(3).uni-tabbar-item--active .uni-tabbar__icon {
	transform: translateY(-4px) scale(1.25) !important;
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}

uni-tabbar .uni-tabbar {
	background: transparent !important;
	border-radius: 20px !important;
	padding-top: 8px !important;
	margin: 0 !important;
	width: 100% !important;
	backdrop-filter: none !important;
	-webkit-backdrop-filter: none !important;
}

/* 为了确保悬浮效果，给页面内容添加底部padding */
.uni-page-body {
	padding-bottom: 112px !important;
}
/* #endif */

/* 小程序端底部导航栏样式 */
/* #ifndef H5 */
.uni-tabbar {
	background: linear-gradient(160deg, 
		rgba(208, 230, 255, 0.45) 30%, 
		rgba(255, 255, 255, 0.5) 60%, 
		rgba(255, 237, 224, 0.45) 90%
	) !important;
	border-radius: 20px !important;
	box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.05) !important;
	margin: 0 12px 12px 12px !important;
	width: auto !important;
}

/* 小程序中间图标3D效果 */
.uni-tabbar-item:nth-child(3) .uni-tabbar__icon {
	transform: translateY(-2px) scale(1.2) !important;
	transition: all 0.3s ease !important;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
	border-radius: 12px !important;
	padding: 6px !important;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.4)) !important;
}

/* 小程序中间图标激活状态 */
.uni-tabbar-item:nth-child(3).uni-tabbar-item--active .uni-tabbar__icon {
	transform: translateY(-4px) scale(1.25) !important;
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}
/* #endif */
</style>